import { render, staticRenderFns } from "./BThemeColor.vue?vue&type=template&id=49a56f0b&scoped=true&"
import script from "./BThemeColor.vue?vue&type=script&lang=js&"
export * from "./BThemeColor.vue?vue&type=script&lang=js&"
import style0 from "./BThemeColor.vue?vue&type=style&index=0&id=49a56f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a56f0b",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QPopupProxy,QColor});
